<div #dropdownMenuTarget class="multiselect-label" [class.-is-no-selection]="isNoSelection">
    @if (checkedVariantLabel) {
        {{ checkedVariantLabel | l10n }}
    } @else {
        {{
            (!checkedVariantsLength || checkedVariantsLength === config.menuItems.length)
                ? (config.isSingleSelectionMode ? ('components.filters.any' | l10n) : '')
                : checkedVariantsLength
        }}
        {{ config.label | l10n }}
    }
</div>
<div class="multiselect_toggle-icon">
    <svg><use xlink:href="#chevron-down"></use></svg>
</div>
